import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { PreloadScene } from './scenes/PreloadScene';
import { WorldScene } from './scenes/WorldScene';
import { HatchScene } from './scenes/HatchScene';
import { PlazaScene } from './scenes/PlazaScene';
import { AtlantisSanctumScene } from './scenes/AtlantisSanctumScene';
import { HalloweenBossIntroScene } from './scenes/HalloweenBossIntroScene';
import { HalloweenBossScene } from './scenes/HalloweenBossScene';
import { TeleportScene } from './scenes/TeleportScene';

/**
 * Tworzy instancję Phaser game i montuje na #game div.
 * Wywoływane raz w main.tsx.
 */
export function createGame(parent: HTMLElement): Phaser.Game {
  const config: Phaser.Types.Core.GameConfig = {
    type: Phaser.AUTO,
    parent,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: '#A8E6A1',
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    // React HUD (#ui) leży nad canvasem i ma własne kontrolki dotykowe.
    // Domyślne `windowEvents:true` każe Phaserowi przetwarzać także gesty,
    // których DOM targetem jest FAB, panel komunikatów, modal lub joystick;
    // współrzędne trafiały wtedy równolegle w hitbox budki pod UI.
    // Wszystkie wejścia świata zaczynają się na canvasie, a joystick jest
    // spięty przez EventBus. Nie używamy Phaser drag/pointerupoutside, więc
    // listenery Window są zbędne i muszą być wyłączone przy tym układzie DOM.
    // Dług na przyszłość: POINTER_UP/DOWN_OUTSIDE nie będą emitowane, a
    // puszczenie nad React UI po starcie na canvasie nie wyzeruje Phaserowego
    // `pointer.isDown`. Przed dodaniem dragów na canvasie trzeba zapewnić im
    // osobną obsługę końca gestu; obecny kod nie odczytuje pointer.isDown.
    input: {
      windowEvents: false,
    },
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { x: 0, y: 0 },   // top-down, brak grawitacji
        debug: false,
      },
    },
    fps: {
      target: 60,
      forceSetTimeOut: false,
    },
    render: {
      antialias: true,
      pixelArt: false,
    },
    // Wyłącz AudioContext — w MVP nie mamy żadnych dźwięków, a Phaser domyślnie
    // próbuje go utworzyć przy starcie, przez co Chrome rzuca:
    // "The AudioContext was not allowed to start. It must be resumed after a user gesture."
    // Włączymy gdy dodamy BGM / SFX (Step 2.B+).
    audio: {
      noAudio: true,
    },
    // HatchScene i TeleportScene to overlay scenes launchowane przez
    // World/Plaza (`scene.launch`). Order matters — Boot/Preload muszą się
    // zarejestrować i wystartować pierwsze; overlaye muszą być znane Phaserowi
    // PRZED launchem (czyli już w configu). TeleportScene LAST → domyślnie
    // najwyżej w kolejności renderu (portal ponad wszystkim; dodatkowo robi
    // `bringToTop` po podmianie sceny).
    scene: [BootScene, PreloadScene, WorldScene, HatchScene, PlazaScene, AtlantisSanctumScene, HalloweenBossScene, HalloweenBossIntroScene, TeleportScene],
  };

  return new Phaser.Game(config);
}
